import { SearchInput } from "../../ui-kit/SearchInput"
import { AutocompleteInput } from "../../ui-kit/AutocompleteInput"
import { CheckboxInput } from "../../ui-kit/CheckboxInput"
import { GRID_FORM_CONFIG_T } from "../../../common/FormGenerator"
import { PROJECTS_FILTRATION } from "../../../consts/formOptions"

export type FiltrationBlockName =
  | "search"
  | "typeProject"
  | "stage"
  | "projectFocus"

export const searchConfig = [
  [
    {
      id: 1,
      controllerName: "search",
      RenderElement: SearchInput,
      renderProps: () => ({
        placeholder: "Поиск...",
        fullWidth: true,
        inputProps: { maxLength: 32 },
      }),
    },
  ],
]

export const typeConfig = [
  [
    {
      id: 2,
      controllerName: "typeProject",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: PROJECTS_FILTRATION.TYPE_PROJECT,
        fullWidth: true,
      }),
    },
  ],
]

export const stageConfig = [
  [
    {
      id: 3,
      controllerName: "stage",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: PROJECTS_FILTRATION.STAGE_PROJECT,
        fullWidth: true,
      }),
    },
  ],
]

export const projectFocusFiltration = [
  [
    {
      id: 4,
      controllerName: "science",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Наука",
      }),
    },
  ],
  [
    {
      id: 5,
      controllerName: "culture",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Культура",
      }),
    },
  ],
  [
    {
      id: 6,
      controllerName: "ecology",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Экология",
      }),
    },
  ],
  [
    {
      id: 7,
      controllerName: "infrastructure",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Инфраструктура",
      }),
    },
  ],
  [
    {
      id: 8,
      controllerName: "urbanEnvironment",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Городская среда",
      }),
    },
  ],
  [
    {
      id: 9,
      controllerName: "healthAndFitness",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Здоровье и физкультура",
      }),
    },
  ],
  [
    {
      id: 10,
      controllerName: "production",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Производство",
      }),
    },
  ],
  [
    {
      id: 11,
      controllerName: "digitalEconomy",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Цифровая экономика",
      }),
    },
  ],
  [
    {
      id: 12,
      controllerName: "education",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Образование",
      }),
    },
  ],
  [
    {
      id: 13,
      controllerName: "family",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Семья",
      }),
    },
  ],
]

const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<any>> = {
  search: searchConfig,
  typeProject: typeConfig,
  stage: stageConfig,
  projectFocus: projectFocusFiltration,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]